import e from"./PJAX/index.js";export default e;
